import React, { Component } from "react";
import {
  withStyles,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
} from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import { styles } from "./track-metadata-grid.css.js";
import { Translation } from "react-i18next";

// import trackFields from "_module/definition/trackFields";
import { AuthSrc } from "util/AuthSrc";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import { connect } from "react-redux";
import Player from "../../../modules/ml-player/Player.js";
import {
  clearAudio,
  setPopoutFor,
} from "../../../redux/actions/PlayerActions.js";
import TextElement from "util/preview-element/TextElement.js";
import moment from "moment";
import Link from "@material-ui/icons/Link.js";
import { getUserDisplay } from "util/CommonFunc.js";
import { DurationDisplayText } from "util/DurationDisplay.js";
class TrackMetadataGrid extends Component {
  constructor(props) {
    super();
    this.state = {
      popOutOpen: false,
      openWindows: {}, // key: trackId, value: true/false
    };
  }





  render() {
    const {
      classes,
      data,
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _trackMusicOrigins: trackOrigins,

        }
      },
    } = this.props;

    const {
    } = this.state;

    return (

      <Translation>
        {(t, { i18n }) => (
          <>
            <Grid container className="popupGrid">

              <Grid container>
                <Grid item xs={6}>
                  <TextElement
                    label={"TRACK TITLE"}
                    classes={classes}
                    data={data[trackFields.trackTitle.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextElement
                    label={"VERSION TITLE"}
                    classes={classes}
                    data={data[trackFields.trackVersionTitle.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={6}>    <TextElement
                  label={"ARTIST"}
                  classes={classes}
                  data={data[trackFields.performer.id]}
                  isPopOut={true}
                /></Grid>
                <Grid item xs={6}><TextElement
                  label={"RECORD LABEL"}
                  classes={classes}
                  data={data[trackFields.recordLabel.id]}
                  isPopOut={true}
                /></Grid>
                <Grid item xs={6}>
                  <TextElement
                    label={"ALBUM TITLE"}
                    classes={classes}
                    data={data[trackFields.prodName.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextElement
                    label={"ALBUM NOTES"}
                    classes={classes}
                    data={data[trackFields.prodNotes.id]}
                    isPopOut={true}
                  />
                </Grid>              
                </Grid>

              <Grid container>
                <Grid item xs={12}>
  <TextElement
                    label={"COMPOSER"}
                    classes={classes}
                    data={data[trackFields.composer.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={12}>
                
                  <TextElement
                    label={"PUBLISHER"}
                    classes={classes}
                    data={data[trackFields.publisher.id]}
                    isPopOut={true}
                  />
                  {/* <TextElement
                label={"ALBUM TITLE"}
                classes={classes}
                showCustomTitle={true}
                customTitle={data[trackFields.prodName.id]}
                data={
                  data[trackFields.prodName.id] ? (
                    <Link
                      aria-label={`Open ${data[trackFields.prodName.id]} album`}
                      style={{ textDecoration: "none", color: "#fff" }}
                      key={data[trackFields.prodId.id]}
                      to={`/search/album/${data[trackFields.prodId.id]}`}
                    >
                      <strong class="tablesLink">
                        {data[trackFields.prodName.id]}
                      </strong>
                    </Link>
                  ) : ""
                }
              /> */}

                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={6}>
                  <TextElement
                    label={"SKY ML ID"}
                    classes={classes}
                    data={data[trackFields.id.id]}
                    isPopOut={true}
                  />


                </Grid>
                <Grid item xs={6}>
                  <TextElement
                    label={"WORKSPACE NAME"}
                    classes={classes}
                    data={data[trackFields.wsName.id]}
                    isPopOut={true}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"PRS TUNE CODE"}
                    classes={classes}
                    data={data[trackFields.prs.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"ORIGIN"}
                    classes={classes}
                    data={`${data[trackFields.musicOrigin.id] ?
                      trackOrigins[data[trackFields.musicOrigin.id]] && trackOrigins[data[trackFields.musicOrigin.id]].label ? (
                        trackOrigins[data[trackFields.musicOrigin.id]].label
                      ) : trackOrigins["origin" + data[trackFields.musicOrigin.id]] &&
                        trackOrigins["origin" + data[trackFields.musicOrigin.id]].label ? (
                        trackOrigins["origin" + data[trackFields.musicOrigin.id]].label
                      ) : (
                        t(`modules.originLables.${data[trackFields.musicOrigin.id]}`)
                      ) : ""}`}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item sm={6} md={3}>
                  {/* <TextElement
                    label={"Non-PPL"}
                    classes={classes}
                    style={data[trackFields.org_sky_PPL.id] == true ? null : { color: 'red', fontWeight: 'bold' }}
                    data={`${data[trackFields.org_sky_PPL.id] == true ? "No" : "Yes" ?? ""}`}
                    isPopOut={true}
                  /> */}
                   <TextElement
                    label={"Non-PPL"}
                    classes={classes}
                    style={data[trackFields.org_sky_PPL.id] == true ? null : { color: 'red', fontWeight: 'bold' }}
                      data={`${data[trackFields.org_sky_PPL.id] == true ? "No" : "Yes"}`}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"ISWC"}
                    classes={classes}
                    data={data[trackFields.iswc.id]}
                    isPopOut={true}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"ISRC"}
                    classes={classes}
                    data={data[trackFields.isrc.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"VOCAL"}
                    classes={classes}
                    data={data[trackFields.org_sky_Vocal.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  {/* <TextElement
                    label={"Non-MCPS"}
                    classes={classes}
                    style={data[trackFields.org_sky_MCPS.id] == true ? null : { color: 'red', fontWeight: 'bold' }}
                    data={`${data[trackFields.org_sky_MCPS.id] == true ? "No" : "Yes" ?? ""}`}
                    isPopOut={true}
                  /> */}
                  <TextElement
                    label={"Non-MCPS"}
                    classes={classes}
                    style={data[trackFields.org_sky_MCPS.id] == true ? null : { color: 'red', fontWeight: 'bold' }}
                      data={`${data[trackFields.org_sky_MCPS.id] == true ? "No" : "Yes"}`}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"MCPS ID"}
                    classes={classes}
                    data={data[trackFields.org_sky_MCPSID.id]}
                    isPopOut={true}
                  />

                </Grid>
              </Grid>

              <Grid container>
                <Grid item sm={6} md={3}>

                  <TextElement
                    label={"COUNTRY"}
                    classes={classes}
                    data={data[trackFields.org_sky_Country.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"RECORDING YEAR"}
                    classes={classes}
                    data={data[trackFields.org_sky_RecordingYear.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"SINGLE RELEASE"}
                    classes={classes}
                    data={`${data[trackFields.org_sky_IsSingleRelease.id] == true ? "Yes" : "No" ?? ""}`}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"CREATED BY"}
                    classes={classes}
                    data={data[trackFields.createdBy.id] ? getUserDisplay(data[trackFields.createdBy.id]) : ""}
                    isPopOut={true}
                  />

                </Grid>
              </Grid>


              <Grid container>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"AREA"}
                    classes={classes}
                    data={data[trackFields.org_sky_Area.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"DECADE"}
                    classes={classes}
                    data={data[trackFields.org_sky_Decade.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"SINGLE RELEASE DATE"}
                    classes={classes}
                    data={`${data[trackFields.org_sky_SingleReleaseDate.id] ? moment(data[trackFields.org_sky_SingleReleaseDate.id]).format("DD/MM/YYYY") || "" : ""}`}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"DATE CREATED"}
                    classes={classes}
                    data={`${data[trackFields.dateCreated.id] ? moment(data[trackFields.dateCreated.id]).format("DD/MM/YYYY") || "" : ""}`}
                    isPopOut={true}
                  />

                </Grid>
              </Grid>

              <Grid container>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"POSITION STRING"}
                    classes={classes}
                    data={data[trackFields.position.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"DUARTION"}
                    classes={classes}
                    data={`${DurationDisplayText({ seconds: data[trackFields.duration.id]})}`}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"SINGLE CHART POSITION"}
                    classes={classes}
                    data={data[trackFields.org_sky_SingleChartPosition.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"MODIFIED BY"}
                    classes={classes}
                    data={data[trackFields.lastEditedBy.id] ? getUserDisplay(data[trackFields.lastEditedBy.id]) : ""}
                    isPopOut={true}
                  />

                </Grid>
              </Grid>
              <Grid container>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"DOWNLOAD ALLOWED"}
                    classes={classes}
                    data={`${data[trackFields.org_sky_DownloadAvailable.id] ? "Yes" : "No" ?? ""}`}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"TEMPO"}
                    classes={classes}
                    data={data[trackFields.numTempo.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"RELEASE DATE"}
                    classes={classes}
                    data={`${data[trackFields.prodRelease.id] ? moment(data[trackFields.prodRelease.id]).format("DD/MM/YYYY") || "" : ""}`}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>

                  <TextElement
                    label={"DATE MODIFIED"}
                    classes={classes}
                    data={`${data[trackFields.dateLastEdited.id] ? moment(data[trackFields.dateLastEdited.id]).format("DD/MM/YYYY") || "" : ""}`}
                    isPopOut={true}
                  />
                </Grid>
              </Grid>


              <Grid container>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"DISC NUMBER"}
                    classes={classes}
                    data={data[trackFields.prodDiscNr.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"BPM"}
                    classes={classes}
                    data={data[trackFields.numBpm.id]}
                    isPopOut={true}
                  />

                </Grid>
                <Grid item sm={6} md={3}>
                  <TextElement
                    label={"CATALOG #"}
                    classes={classes}
                    data={data[trackFields.catNo.id]}
                    isPopOut={true}
                  />

                </Grid>

              </Grid>

              <Grid container>
                <Grid item xs={12}>
                  <TextElement
                    label={"STYLE"}
                    classes={classes}
                    data={data[trackFields.styles.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextElement
                    label={"NOTES"}
                    classes={classes}
                    data={data[trackFields.trackNotes.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextElement
                    label={"LIBRARIAN NOTES"}
                    classes={classes}
                    data={data[trackFields.org_sky_LibrarianNotes.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextElement
                    label={"LYRICS"}
                    classes={classes}
                    data={data[trackFields.org_sky_Lyrics.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextElement
                    label={"ALBUM NOTES"}
                    classes={classes}
                    data={data[trackFields.prodNotes.id]}
                    isPopOut={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextElement
                    label={"ALBUM LIBRARIAN NOTES"}
                    classes={classes}
                    data={data[trackFields.org_sky_prodLibrarianNotes.id]}
                    isPopOut={true}
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Translation>
    );
  }

}


const mapStateToProps = (state) => ({
  orgRuntime: state.orgRuntime,
});


export default connect(
  mapStateToProps,
  {
    clearAudio,
    setPopoutFor,
  }
)(withStyles(styles)(TrackMetadataGrid));
